export default {
  text: 'Olá Mundo!'
}
